export default {
  account (state) {
    return state.account
  },
  station (state) {
    return state.station
  },
  filaNormal (state) {
    return state.station.filaNormal
  },
  filaPreferencial (state) {
    return state.station.filaPreferencial
  },
  CurrentClienteNormal (state) {
    return state.station.CurrentClienteNormal
  },
  CurrentClientePreferencial (state) {
    return state.station.CurrentClientePreferencial
  }
}
